// @flow
import { result } from 'lodash';
import * as React from 'react';

import { useTranslation } from 'react-i18next';
import ImagePlaceholder from '../../../components/image-placeholder';
import { Apartment } from '@mui/icons-material';

import styles from './styles.module.scss';

type Props = {
  results: Talent[],
  index: number,
  value: string,
  showAll: boolean,
  onSubmit: (e: any) => void,
  onShowAll: () => void,
};

const Suggestions = ({
  results,
  index,
  onSubmit,
  value,
  showAll,
  onShowAll,
}: Props) => {
  const { t } = useTranslation();


  // Highlight the `show-all` row if the last index is chosen
  const showAllRowStyles = [
    results.length
      ? styles.search_results_show_all_wrapper
      : styles.search_results_show_all_wrapper_alone,
  ];
  if (index === results.length) {
    showAllRowStyles.push(styles.active);
  }

  return (
    <div className={styles.search_results}>
      {results.map((r, i) => {
        // There is always a highlighted result, that is chosen by
        // the `index` prop
        const rowStyles = [styles.search_result_row];
        if (index === i) {
          rowStyles.push(styles.active);
        }
        const handleClick = () => onSubmit(r);

        if (r.validation.type === 'LEGAL_ENTITY') return (
          <div className={rowStyles.join(' ')} key={r.uuid} onClick={handleClick}>
            <div className={styles.search_result_image_holder}>
              <div style={{ marginLeft: '5px', borderRadius: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px', width: '30px', borderStyle: 'solid', borderWidth: '1px', borderColor: '#E1E1E1', background: 'white' }}>
                <Apartment style={{ color: '#908E8C' }} />
              </div>
            </div>
            <span className={styles.search_result_text}>
              {r.name}
            </span>
            {/* {r.legal_entity.address &&
              <span className={styles.search_result_email}>
                (
                 {(r?.legal_entity?.address?.location?.province ? r?.legal_entity?.address?.location?.province : r?.legal_entity?.address?.location?.country_long)}
                 )
              </span>
            } */}
            <span className={styles.search_result_email}>

              {r.validation.isArchived
                ? ' [ARCHIVED]'
                : null}

            </span>
          </div>
        )

        if (r.validation.type === 'INDIVIDUAL') return (
          <div className={rowStyles.join(' ')} key={r.uuid} onClick={handleClick}>
            <div className={styles.search_result_image_holder}>
              <ImagePlaceholder src={r?.user?.picture} alt="search picture" />
            </div>
            <span className={styles.search_result_text}>
              {r.firstName} {r.lastName}
            </span>
            {/* <span className={styles.search_result_email}>
              (
              {r.company.product_type === 'SECURITY'
                ? (r.user.address.location.city ? r.user.address.location.city : r.user.address.location.province)
                : r.user.email}
              )
            </span> */}
            <span className={styles.search_result_email}>

              {r.validation.isArchived
                ? ' [ARCHIVED]'
                : null}

            </span>
          </div>
        );
      })}
      {value && showAll && (
        <div className={showAllRowStyles.join(' ')} onClick={onShowAll}>
          <span className={styles.search_results_show_all}>
            {t('sentences:search_show_all', { value })}
          </span>
        </div>
      )}
    </div>
  );
};

export default Suggestions;
